/* eslint-disable */
import {
  Box,
  FormControlLabel,
  Checkbox, 
  Typography,
} from '@mui/material'
import DividerTAG from '../DividerTAG'
import CardTAG from '../CardTAG'
import React from 'react'
import FormLayout from '../forms/FormLayout'
import { useDispatch, useSelector } from 'react-redux'
import reportsSelectors from '../../store/reports/reportsSelectors'
import { AppDispatch } from '../../store'
import {
  findItemByUuid,
  updateAnswerOption
  
} from '../../store/reports/reportsSlice'
import { IQuestionComponent } from './types'
import utils from '../CaseInvestigation/utils'
import authSelectors from '../../store/auth/authSelectors'



const CheckboxQuestionComponent: React.FC<IQuestionComponent> = ({
  questionObj,
  question,
  questionUUID,
  questionId,
  questionOptions,
  control,
  fieldName,
  unregister,
  setValue,
  setAnswersFiles,
  answers = [],
  answer: _answer,
  parent,
  previewOnly = false,
}) => {
  
  const dispatch = useDispatch<AppDispatch>()
  const userEditAccess = useSelector(authSelectors.userReportEditAccess)
  const getAnswer = () => {
    if (answers && answers?.length > 0) {
      return findItemByUuid(answers, questionUUID)
    }
    return useSelector(reportsSelectors.answersToCaseTypeQuestion(questionUUID))
  }
  const answer = _answer ? _answer : getAnswer() 


  const onChangeHandler = (event: { target: { value: string, checked?: any | undefined } }) => {
    if (!userEditAccess || previewOnly) {
      return
    }
    let value = [...(answer?.options ?? []), event?.target?.value as unknown as number]
    if (event?.target?.checked === false) {
      value = answer?.options?.filter((id: any) => id !== event?.target?.value as unknown as number)
    }
    dispatch(
      updateAnswerOption({
        answerUUID: answer?.uuid,
        answerText: value,
        parentUUID: parent?.uuid
      }),
    )
  }

  const resolveChecked = (optionId: number) => {
    if (!answer) return false

    return answer?.options?.filter((id: any) => id == optionId).length > 0
  }

  const optionsAndSubquestions = questionObj?.options.map((option : any) => {
    const found = questionObj?.subquestions.filter((subQuestion : any) => subQuestion?.option === option.id)
    return found?.length > 0
      ? {
          option,
          subquestions: found,
        }
      : {
          option,
        }
  })


  // optionsAndSubquestions.sort((a, b) => {
  //   if (a.option.id === 30) return 1
  //   if (b.option.id === 30) return -1
  //   return 0
  // })

  const renderOptions = () => {
    return optionsAndSubquestions.map((option : any) => {
      return (
        <>
          <FormControlLabel
            control={
              <Checkbox
                disabled={!userEditAccess || previewOnly}
                value={option?.option.id}
                onChange={onChangeHandler}
                checked={resolveChecked(option?.option.id)}
              />
            }
            label={option?.option.text}
          />
          <DividerTAG />
        </>
      )

    })
  }

  const resolveSubquestions = () => {
    if (questionObj?.subquestions && questionObj?.subquestions?.length) {
      return optionsAndSubquestions.map((option : any) => {
        if (resolveChecked(option?.option.id)) {
          const subquestions = questionObj?.subquestions.filter((subquestion: any) => subquestion?.option === option?.option.id)
          return subquestions?.map((subquestion : any)  =>
            utils.questionParser(
                subquestion,
                control,
                unregister,
                setValue,
                setAnswersFiles,
                answers,
                answer,
                previewOnly
            )
          )
        }
      })
    }
    return null
  }


  return (
    <>
      <div id={`${questionId}`}>
        <CardTAG
          questionCard={true}
          color={`${previewOnly ? 'tagBoxArchive' : 'tagBoxSuccess'}`}
          title={
            <Box sx={{ wordWrap: 'break-word', whiteSpace: 'unset', textOverflow: 'unset' }}>
              <Typography
                variant='h4'
                sx={{
                  wordWrap: 'break-word',
                  overflow: 'hidden',
                }}
              >
                {question}
              </Typography>
            </Box>
          }
          
        >
          <FormLayout>
              {renderOptions()}
          </FormLayout>
        
        </CardTAG>
      </div>
      {resolveSubquestions()}
    </>
  )
  
}

export default CheckboxQuestionComponent
